module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"tags":"Etiket Yönetimi","locationsManagement":"Lokasyon ve Sektör Yönetimi","emissionLibraryManagement":"Emisyon Kütüphanesi Yönetimi"},"en":{"tags":"Tag Management","locationsManagement":"Location & Sector Management","emissionLibraryManagement":"Emission Library Management"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Setting/Master.vue
// module id = DDy4
// module chunks = 1